import { useSelector } from 'react-redux'
import style from './SubtitleVideo.module.scss'
import { selectMovie } from '../../../../../redux/movieSlices/MovieSelector'

type MovieSubtitleProps = {
    yt_trailer: string;
}
type Cast = {
    name: string;
    character_name: string;
    url_small_image: string;
}


let SubtitleVideo: React.FC<MovieSubtitleProps> = ({ yt_trailer }) => {

    let { movie } = useSelector(selectMovie)

    let cast = [{ name: '', character_name: '', url_small_image: '' }]
    try {
        if (movie.cast !== undefined) {
            cast = movie.cast
        }
    } catch {
        cast = [{ name: '', character_name: '', url_small_image: '' }]
    }

    return (
        <div className={style.subtitle__video}>
            <iframe width="90%" height="550" src={yt_trailer} className={style.video}
                title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" >
            </iframe>
            <div className={style.video__cast}>
                {cast.map((el: Cast) => <div className={style.cast}><span>{el.name}</span>
                    <span>{el.character_name}</span><img src={el.url_small_image} /></div>)}
            </div>
        </div>
    )
}

export default SubtitleVideo;